import AccessDenied from './access-denied.view.vue';

export default [
  {
    path: '/access-denied',
    component: AccessDenied,
    name: 'access-denied',
  },
];
